
import WDElement from '../wd-element';
import WDButton from '../button/wd-button';
import WDNavbarMenu from './wd-navbar-menu';
import WDNavbarMenuPager from './wd-navbar-menu-pager';
import WDNavbarFilter from '../filter/wd-navbar-filter';

export default class WDNavbar extends WDElement
{
	#options = { toggler_icon: 'fa-solid fa-bars' };
	#prefix = null;
	#suffix = null;
	#left = null;
	#center = null;
	#right = null;
	#toggleButton = null;
	#toggleIcon = 'fa-solid fa-bars';

	constructor(opts)
	{
		super().setAttribute('role', 'navigation');
		this.classList.add('wd-navbar');
		//this.dataset.menuCount = '0';

		if (opts) this.#options = Object.assign({}, this.#options, opts);

		return this;
	};

	/** adds a new menu to the navbar **/
	add(cfg)
	{
		const menu = new WDNavbarMenu(cfg);
		this.append(menu);

		return menu;
	};

	get prefix()
	{
		if (!this.#prefix) 
		{
			this.#prefix = this.add();
			this.#prefix.classList.add('wd-navbar-menu-prefix');
		}
		return this.#prefix;
	};

	get suffix()
	{
		if (!this.#suffix) 
		{
			this.#suffix = this.add();
			this.#suffix.classList.add('wd-navbar-menu-suffix');
		}
		return this.#suffix;
	};

	set collapsible(val)
	{
		if (val === false)
		{
			this.classList.remove('is-collapsible');
			delete this.dataset.collapseBreakpoint;
			if (this.#toggleButton) this.toggleButton.remove();
		}
		else
		{
			this.classList.add('is-collapsible');
			this.dataset.collapseBreakpoint = WDConfig?.navbar?.bootstrapBreakpoint || 'md';

			if (val === true || val == 'menu') this.suffix.append(this.toggleButton);
		}
	}

	set toggleIcon(val)
	{
		this.#toggleIcon = val;
		this.#toggleButton.icon = this.#toggleIcon;
	}

	get toggleButton()
	{
		if (!this.#toggleButton)
		{
			this.#toggleButton = new WDButton({ icon: this.#toggleIcon });
			this.#toggleButton.classList.add('wd-navbar-menu-toggler');
			this.#toggleButton.on('click', () => this.classList.toggle('is-open'));
		}

		return this.#toggleButton;
	};

	get left()
	{
		if (!this.#left) 
		{
			this.#left = this.add();
			this.#left.classList.add('wd-navbar-menu-left');
			//this.dataset.menuCount = parseInt(this.dataset.menuCount) + 1;
		}
		return this.#left;
	};

	get center()
	{
		if (!this.#center) 
		{
			this.#center = this.add();
			this.#center.classList.add('wd-navbar-menu-center');
			//this.dataset.menuCount = parseInt(this.dataset.menuCount) + 1;
		}
		return this.#center;
	};

	get right()
	{
		if (!this.#right) 
		{
			this.#right = this.add();
			this.#right.classList.add('wd-navbar-menu-right');
			this.classList.add('has-right-menu');
			//this.dataset.menuCount = parseInt(this.dataset.menuCount) + 1;
		}
		return this.#right;
	};

	addBreadcrumbs()
	{
		const crumbs = new WDNavbarMenu();
		crumbs.classList.add('wd-navbar-breadcrumbs');

		this.append(crumbs);
		return crumbs;
	};

	addPager()
	{
		const pager = new WDNavbarMenuPager();
		this.append(pager);
		return pager;
	};

	addFilters(cfg)
	{
		const f = new WDNavbarFilter(cfg);
		this.append(f);
		this.classList.add('has-filters');

		return f;
	};

	/**
	 * Cleanup callback - called when navbar is truly removed from DOM
	 * Inherits from WDElement's deferred cleanup pattern
	 */
	cleanupCallback()
	{
		// Call parent cleanup FIRST
		super.cleanupCallback();
		
		// Clear menu references
		this.#toggleButton = null;
		this.#prefix = null;
		this.#suffix = null;
		this.#left = null;
		this.#center = null;
		this.#right = null;
		this.#options = null;
	}

};

customElements.define('wd-navbar', WDNavbar);
